// src/shared/lib/quiet-loading-route.ts
//
// PROD-3194: the app-level loading gates (boot, session) read this so an encounter link opened cold draws no
// brand spinner at any stage.
/** The routes that draw no brand spinner while they load: the encounter (`/encounter/:appointmentId`). */
export function isQuietLoadingRoute(pathname: string): boolean {
  return pathname.startsWith('/encounter/');
}
